import styled, {
  breakpoints,
  css,
  Device,
  IFalconTheme,
  Layout,
  ResponsiveTypography,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

export { ImageContainer, ImageText, PropositonContainer, TitleWrapper, MainContainer };

const ImageContainer: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    display: flex;
    flex: 1;
    text-align: left;
    align-items: center;
    justify-content: center;
    margin-bottom: ${Scale.s};
    img {
      object-position: left;
      width: auto;
    }
    @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
      display: inline-block;
      margin: 0 ${Scale.s};
      text-align: center;
      align-items: center;
      justify-content: center;
      img {
        object-position: center;
      }
    }
  `;
});

const PropositonContainer: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    display: block;
    background: white;
    width: 100%;
    @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
      display: inline-flex;
      flex-direction: row;
    }
  `;
});

const TitleWrapper: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    text-align: left;
    background: white;
    padding-bottom: ${Scale.l};
    @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
      text-align: center;
    }
  `;
});

const MainContainer: StyledComponent<typeof Layout.Wrapper, IFalconTheme, {}> = styled(
  Layout.Wrapper
)`
  font-family: ${({ theme }) => theme.fontFamilyBody.join(',')};
  text-align: center;
  background: white;
  display: block;
  padding: ${Scale.l};
`;

const ImageText: StyledComponent<typeof ResponsiveTypography, IFalconTheme, {}> = styled(
  ResponsiveTypography
)`
  flex-grow: 1;
  padding-left: ${Scale.xs};
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    padding: 0;
  }
`;
